module.exports = __webpack_public_path__ + "static/media/Reports.a227a978.svg";